import React, { useState, useEffect } from "react";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import { useHistory, useParams } from "react-router-dom";
import { Table } from "antd";
import moment from "moment";
import swal from "sweetalert";
import "../../InsuranceNew/InsuranceDashboard.css";
import FETCH from "../../../utils/fetch";
import { MODULE_API } from "../../../apis";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";

export const UmbrellaInsuranceTable = ({
  setPayload,
  setAttributeValues,
  payload,
  attributeValues,
}) => {
  const history = useHistory();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [insuranceData, setInsuranceData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [cachedData, setCachedData] = useState({});
  const [selecting, setSelecting] = useState(false);
  const getInsuranceList = async (page) => {
    if (cachedData && cachedData[page]) {
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Property and Casualty&page=${page}&limit=10&clientId=${ID}`
            : `?module=Property and Casualty&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      const dataSource =
        payload["Original Policies"] ||
        attributeValues["Original Policies"] ||
        [];
      const uniqueIds = [...new Set(dataSource.filter(Boolean))];
      const filtered = datares.records.filter(function (item) {
        return item.module !== "Umbrella V2" && !uniqueIds.includes(item.id);
      });
      setInsuranceData(datares.records);
    }
    if (datares && datares.pagination) {
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };
  const getInsuarnceListAfterDelete = async (page) => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Property and Casualty&page=${page}&limit=10&clientId=${ID}`
            : `?module=Property and Casualty&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleAdd = async (record) => {
    if (selecting) return;
    // Step 1: Prepare the payload
    try {
      // Step 2: Call API to create the asset/module
      setSelecting(true);
      setLoading(true);
      let newId;

      if (record["Under the Umbrella"] === true) {
        // Use the existing ID directly
        newId = record.id;
      } else {
        // Call API to create new module
        const moduleNew = await MODULE_API.addAsset(record.module + " Copy", {
          clientModules: [
            {
              ...record,
              "Under the Umbrella": true,
              "Original Policy Number": record.id,
            },
          ],
        });
        setCachedData({});
        setInsuranceData([]);
        await getInsuarnceListAfterDelete(1);

        if (
          moduleNew &&
          moduleNew.clientModules &&
          moduleNew.clientModules.length > 0 &&
          moduleNew.clientModules[0].id
        ) {
          newId = moduleNew.clientModules[0].id;
        } else {
          console.error("Failed to get module ID");
          setLoading(false);
          return;
        }
      }

      // Step 4: Update the payload with new module ID
      setLoading(false);

      setPayload((prevValue) => {
        const linked = prevValue["Linked Policies"] || [];
        const original = prevValue["Original Policies"] || [];

        const updatedLinked = linked.includes(newId)
          ? linked
          : [...linked, newId];
        const updatedOriginal = original.includes(newId)
          ? original
          : [...original, record.id];
        const prevPremium = parseFloat(prevValue["Premium"] || 0);
        const hasAnnualKey =
          record.hasOwnProperty("Annual or Monthly") ||
          record.hasOwnProperty("Annual / Monthly / One-Time");

        const isAnnual =
          record["Annual or Monthly"] === "Annual" ||
          record["Annual / Monthly / One-Time"] === "Annual";

        const addedPremium =
          hasAnnualKey && isAnnual
            ? parseFloat((record["Premium"] || 0) / 12)
            : parseFloat(record["Premium"] || 0);

        return {
          ...prevValue,
          ["Linked Policies"]: updatedLinked,
          ["Original Policies"]: updatedOriginal,
          ["Premium"]: prevPremium + addedPremium,
        };
      });
    } catch (error) {
      setLoading(false);
      console.error("Failed to add asset:", error);
    } finally {
      setSelecting(false);
    }
  };

  const handleDelete = (record) => {
    const hasAnnualKey =
      record.hasOwnProperty("Annual or Monthly") ||
      record.hasOwnProperty("Annual / Monthly / One-Time");

    const isAnnual =
      record["Annual or Monthly"] === "Annual" ||
      record["Annual / Monthly / One-Time"] === "Annual";

    const recordPremium =
      hasAnnualKey && isAnnual
        ? parseFloat((record["Premium"] || 0) / 12)
        : parseFloat(record["Premium"] || 0);
    if (record["Under the Umbrella"] && record["Under the Umbrella"] === true) {
      deletePost(record.id);
    }
    setPayload((prevValue) => {
      const existingLinked = prevValue["Linked Policies"] || [];
      const existingOriginal = prevValue["Original Policies"] || [];

      const updatedLinked = existingLinked.filter(
        (id) => id && id.toString() !== record.id.toString()
      );

      const updatedOriginal = existingOriginal.filter((id) => {
        const originalPolicyNumber = record["Original Policy Number"];
        return (
          id &&
          id.toString() !== record.id.toString() &&
          (!originalPolicyNumber ||
            id.toString() !== originalPolicyNumber.toString())
        );
      });

      const prevPremium = parseFloat(prevValue["Premium"] || 0);
      const newPremium = Math.max(0, prevPremium - recordPremium);

      return {
        ...prevValue,
        ["Linked Policies"]: updatedLinked.length > 0 ? updatedLinked : [null],
        ["Original Policies"]:
          updatedOriginal.length > 0 ? updatedOriginal : [null],
        ["Premium"]: newPremium,
      };
    });
    setAttributeValues((prevValue) => {
      const existingLinked = prevValue["Linked Policies"] || [];
      const existingOriginal = prevValue["Original Policies"] || [];

      const updatedLinked = existingLinked.filter(
        (id) => id && id.toString() !== record.id.toString()
      );

      const updatedOriginal = existingOriginal.filter((id) => {
        const originalPolicyNumber = record["Original Policy Number"];
        return (
          id &&
          id.toString() !== record.id.toString() &&
          (!originalPolicyNumber ||
            id.toString() !== originalPolicyNumber.toString())
        );
      });
      const prevPremium = parseFloat(prevValue["Premium"] || 0);
      const newPremium = Math.max(0, prevPremium - recordPremium);

      return {
        ...prevValue,
        ["Linked Policies"]: updatedLinked.length > 0 ? updatedLinked : [null],
        ["Original Policies"]:
          updatedOriginal.length > 0 ? updatedOriginal : [null],
        ["Premium"]: newPremium,
      };
    });
  };
  const getInsuranceFieldsData = async (id) => {
    setLoading(true);
    try {
      const res = await MODULE_API.fetchSingleGoalDetails(id);
      if (res && res.data) {
        return res.data;
      }
    } finally {
      setLoading(false);
    }
  };
  const getLinkedInsurnceData = async () => {
    const dataSource =
      payload["Linked Policies"] || attributeValues["Linked Policies"] || [];

    // Step 1: Make IDs unique and filter falsy values
    const uniqueIds = [...new Set(dataSource.filter(Boolean))];

    if (uniqueIds.length === 0) {
      setSelectedData([]); // Empty if nothing to fetch
      return;
    }

    setLoading(true);
    try {
      // Step 2: Fetch all insurance data using Promise.all
      const results = await Promise.all(
        uniqueIds.map((id) => getInsuranceFieldsData(id))
      );

      // Step 3: Set the fetched data into state
      const validResults = results.filter((item) => !!item); // Remove any nulls
      setSelectedData(validResults);
    } catch (error) {
      console.error("Error fetching insurance data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInsuranceList(currentPage);
  }, [currentPage]);

  useEffect(() => {
    getLinkedInsurnceData();
  }, [payload, attributeValues]);

  const cols_insurance = [
    {
      title: "Policy Name",
      dataIndex: "Policy Name (Person(s)/Property Insured)",
      key: "Policy Name (Person(s)/Property Insured)",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Start Date",
      dataIndex: "Policy Start Date",
      key: "Policy Start Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Policy End Date",
      dataIndex: "Policy End Date",
      key: "Policy End Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Insurance Company",
      dataIndex: "Insurance Company",
      key: "Insurance Company",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Number",
      dataIndex: "Policy Number",
      key: "Policy Number",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monthly Premium",
      dataIndex: "Premium",
      key: "Premium",
      render: (_, record) => {
        const isAnnual =
          record["Annual / Monthly / One-Time"] === "Annual" ||
          record["Annual or Monthly"] === "Annual";

        const amount = isAnnual ? record.Premium / 12 : record.Premium;

        return amount
          ? `$ ${amount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "N/A";
      },
    },
    {
      title: "Select this Insurance",
      render: (record) => {
        const dataSource =
          payload["Original Policies"] ||
          attributeValues["Original Policies"] ||
          [];
        let isDisabled =
          dataSource &&
          dataSource.some(
            (item) => item && item.toString() === record.id.toString()
          );
        return (
          <React.Fragment>
            <button
              className="saveStatusbutton"
              disabled={selecting}
              style={{
                width: "100%",
                fontWeight: "bold",
                background: `${isDisabled ? "#E13C25" : ""}`,
                opacity: `${selecting ? 0.5 : 1}`,
              }}
              onClick={async (e) => {
                e.preventDefault();
                if (isDisabled) {
                  handleDelete(record);
                } else {
                  handleAdd(record);
                }
              }}
            >
              {isDisabled ? "Selected" : "Select"}
            </button>
          </React.Fragment>
        );
      },
    },
    // {
    //   title: "Actions",
    //   key: "id",
    //   render: (record, index) => {
    //     return (
    //       <div key={index}>
    //         <div
    //           onClick={() => {
    //             if (
    //               record["Under the Umbrella"] &&
    //               record["Under the Umbrella"] === true &&
    //               id
    //             ) {
    //               getSelectedRow(record.id);
    //               setDropdown(!dropdown);
    //             }
    //           }}
    //           style={{
    //             cursor:
    //               record["Under the Umbrella"] &&
    //               record["Under the Umbrella"] === true &&
    //               id
    //                 ? "pointer"
    //                 : "not-allowed",
    //             marginRight: "1rem",
    //             padding: "0px 16px",
    //             width: "5px",
    //           }}
    //         >
    //           <img src={menuIcon} alt="menuIcon"></img>
    //         </div>
    //         {dropdown && selectedIndex === record.id && (
    //           <React.Fragment>
    //             <div
    //               onClick={() => {
    //                 setDropdown(false);
    //               }}
    //               className=""
    //               style={{
    //                 position: "fixed",
    //                 width: "100vw",
    //                 height: "100vh",
    //                 background: "black",
    //                 opacity: "0.1",
    //                 top: "0",
    //                 left: "0",
    //                 right: "0",
    //                 bottom: "0",
    //                 zIndex: "999",
    //               }}
    //             ></div>

    //             <div className="dropdown" style={{ zIndex: "9999" }}>
    //               <ul className="dropdownul">
    //                 <li
    //                   className="liHover"
    //                   onClick={() => {
    //                     fnView(record);
    //                     setDropdown(false);
    //                   }}
    //                 >
    //                   View
    //                 </li>

    //                 <li
    //                   className="liHover"
    //                   onClick={() => {
    //                     fnEdit(record);
    //                     setDropdown(false);
    //                   }}
    //                 >
    //                   Update
    //                 </li>
    //                 <li
    //                   className="liHover"
    //                   onClick={() => {
    //                     deletePost(record.id);
    //                     setDropdown(false);
    //                   }}
    //                 >
    //                   Delete
    //                 </li>
    //               </ul>
    //             </div>
    //           </React.Fragment>
    //         )}{" "}
    //       </div>
    //     );
    //   },
    // },
  ];
  const cols_insurance_Seleted = [
    {
      title: "Policy Name",
      dataIndex: "Policy Name (Person(s)/Property Insured)",
      key: "Policy Name (Person(s)/Property Insured)",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Start Date",
      dataIndex: "Policy Start Date",
      key: "Policy Start Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Policy End Date",
      dataIndex: "Policy End Date",
      key: "Policy End Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Insurance Company",
      dataIndex: "Insurance Company",
      key: "Insurance Company",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Number",
      dataIndex: "Policy Number",
      key: "Policy Number",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monthly Premium",
      dataIndex: "Premium",
      key: "Premium",
      render: (_, record) => {
        const isAnnual =
          record["Annual / Monthly / One-Time"] === "Annual" ||
          record["Annual or Monthly"] === "Annual";

        const amount = isAnnual ? record.Premium / 12 : record.Premium;

        return amount
          ? `$ ${amount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "N/A";
      },
    },
    {
      title: "Select this Insurance",
      render: (record) => {
        const dataSource =
          payload["Linked Policies"] ||
          attributeValues["Linked Policies"] ||
          [];

        let isDisabled =
          dataSource &&
          dataSource.some(
            (item) => item && item.toString() === record.id.toString()
          );

        return (
          <React.Fragment>
            <button
              className="saveStatusbutton"
              // disabled={payload && payload["Original Policies"].includes(record.id) || deSelecting || !isDisabled}
              disabled={loading}
              style={{
                width: "100%",
                // opacity: `${payload && payload["Original Policies"].includes(record.id) ? 0.5 : 1}`,
                opacity: `${loading ? 0.5 : 1}`,
                fontWeight: "bold",
                // background: `${isDisabled ? "#E13C25" : ""}`,
                background: "#E13C25",
              }}
              onClick={async (e) => {
                e.preventDefault();
                if (isDisabled) {
                  handleDelete(record);
                } else {
                  // handleAdd(record);
                }
              }}
            >
              {isDisabled ? "Selected" : "Select"}
            </button>
          </React.Fragment>
        );
      },
    },
    // {
    //   title: "Actions",
    //   key: "id",
    //   render: (record, index) => {
    //     return (
    //       <div key={index}>
    //         <div
    //           onClick={() => {
    //             if (
    //               record["Under the Umbrella"] &&
    //               record["Under the Umbrella"] === true &&
    //               id
    //             ) {
    //               getSelectedRow(record.id);
    //               setDropdown(!dropdown);
    //             }
    //           }}
    //           style={{
    //             cursor:
    //               record["Under the Umbrella"] &&
    //               record["Under the Umbrella"] === true &&
    //               id
    //                 ? "pointer"
    //                 : "not-allowed",
    //             marginRight: "1rem",
    //             padding: "0px 16px",
    //             width: "5px",
    //           }}
    //         >
    //           <img src={menuIcon} alt="menuIcon"></img>
    //         </div>
    //         {dropdown && selectedIndex === record.id && (
    //           <React.Fragment>
    //             <div
    //               onClick={() => {
    //                 setDropdown(false);
    //               }}
    //               className=""
    //               style={{
    //                 position: "fixed",
    //                 width: "100vw",
    //                 height: "100vh",
    //                 background: "black",
    //                 opacity: "0.1",
    //                 top: "0",
    //                 left: "0",
    //                 right: "0",
    //                 bottom: "0",
    //                 zIndex: "999",
    //               }}
    //             ></div>

    //             <div className="dropdown" style={{ zIndex: "9999" }}>
    //               <ul className="dropdownul">
    //                 <li
    //                   className="liHover"
    //                   onClick={() => {
    //                     fnView(record);
    //                     setDropdown(false);
    //                   }}
    //                 >
    //                   View
    //                 </li>

    //                 <li
    //                   className="liHover"
    //                   onClick={() => {
    //                     fnEdit(record);
    //                     setDropdown(false);
    //                   }}
    //                 >
    //                   Update
    //                 </li>
    //                 <li
    //                   className="liHover"
    //                   onClick={() => {
    //                     deletePost(record.id);
    //                     setDropdown(false);
    //                   }}
    //                 >
    //                   Delete
    //                 </li>
    //               </ul>
    //             </div>
    //           </React.Fragment>
    //         )}{" "}
    //       </div>
    //     );
    //   },
    // },
  ];
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const deletePost = async (id) => {
    console.log("delete is", id);
    // swal({
    //   title: "Are you sure?",
    //   text: "You want to delete this?",
    //   icon: "warning",
    //   buttons: true,
    //   dangerMode: true,
    // }).then(async (result) => {
    //   if (result === true) {
    //     setLoading(true);
    //     try {
    //       const res = await MODULE_API.removeClientModule({
    //         clientModules: [id],
    //       });
    setCachedData({});
    setInsuranceData([]);
    await getInsuarnceListAfterDelete(1);
    //   } catch (error) {
    //     setLoading(false);
    //   }
    // }
    // });
  };
  const fnEdit = (record) => {
    history.push(
      `/organizer/insurance/attributes/${record.module}/${record.id}`
    );
  };
  const fnView = (record) => {
    history.push(
      `/organizer/insurance/attributes/${record.module}/${record.id}/view`
    );
  };
  const dataSource =
    payload["Original Policies"] || attributeValues["Original Policies"] || [];
  const uniqueIds = [...new Set(dataSource.filter(Boolean))];

  // Filter out entries where the module is "Umbrella V2" or the ID is in uniqueIds
  const filteredInsuranceData =
    insuranceData &&
    insuranceData.filter((item) => {
      return (
        item.module !== "Umbrella V2" &&
        !uniqueIds.map(String).includes(item.id.toString())
      );
    });
  return (
    <React.Fragment>
      {" "}
      <div className="insuranceInfoMaincard" style={{ position: "relative" }}>
        <h3
          className="liablitycardheading"
          style={{ display: "flex", gap: "3px", alignItems: "baseline" }}
        >
          Insurance Policies Under Umbrella{" "}
          <ToolTipCreator name={"Insurance Policies Under Umbrella"} />
        </h3>
        <Table
          columns={cols_insurance_Seleted}
          dataSource={selectedData && selectedData}
        />
        <NewLoader isLoading={loading} />
      </div>
      <div className="insuranceInfoMaincard" style={{ position: "relative" }}>
        <h3
          className="liablitycardheading"
          style={{ display: "flex", gap: "3px", alignItems: "baseline" }}
        >
          Insurance Policies Selection{" "}
          <ToolTipCreator name={"Insurance Policies Selection"} />
        </h3>
        <Table
          columns={cols_insurance}
          dataSource={filteredInsuranceData}
          pagination={{
            total: totalPages * 10, // Assuming 10 items per page
            current: currentPage,
            onChange: (page) => {
              setCurrentPage(page);
            },
            pageSize: 10, // Number of items per page
          }}
        />
        <NewLoader isLoading={loading} />
      </div>
    </React.Fragment>
  );
};
